"use strict";
const factory = (params) => {
  return (text, position) => {
    const data = _.extend(
      {},
      params,
      {
        value: text,
        position
      }
    );
    return $.ajax({
      url: "/api/text_drops/",
      type: "post",
      data: JSON.stringify(data),
      contentType: "application/json"
    });
  };
};
export default {
  createForDocumentAndField(document, field) {
    return factory({
      document_id: document.id,
      field
    });
  }
};
